import type { ComponentProps, ReactElement } from "react";

import OverlayHook from "../OverlayHook/OverlayHook";

import { StyledFloatOverlayHookWrapper } from "./styles";

type Props = ComponentProps<typeof OverlayHook> & {
    bottom?: number;
};

const FloatOverlayHook = ({ bottom, ...props }: Props): ReactElement => {
    return (
        <StyledFloatOverlayHookWrapper
            bottom={bottom}
            data-automation="float-overlay-hook-wrapper"
        >
            <OverlayHook {...props} />
        </StyledFloatOverlayHookWrapper>
    );
};

export default FloatOverlayHook;
